export const teGenericDescription =
  "Connect with any webhook to automatically sync applicant data from Team Engine. If you track applicants or employees in an external system that we don't currently integrate with, this might be right for you.";

export const teGenericEditDescription = 'Learn more on integrating with webhooks';
